import React from 'react';
import CustomDeletePage from 'components/custom-pages/CustomDelete';

const Delete = ({ data, handleClick }) => {
  return (
    <CustomDeletePage
      pageTitle={'Delete Mechanical Condition'}
      url={'mechanical-condition-reason-master'}
      queryKey="mechanical-condition-reason-master"
      title={'Mechanical Condition Reason'}
      id={data?._id}
      handleClick={handleClick}
    />
  );
};

export default Delete;
